import { applyMiddleware, combineReducers, createStore } from "redux";
import createSagaMiddleware from "redux-saga";

import initialState from "./initialState";
import auth from "../modules/login/state/LoginReducer";
import user from "../modules/user-management/state/UserReducer";
// import notification from "../modules/admin/notification/state/NotificationReducer";
import rootSaga from "../services/watchSaga";
import holdco from "../modules/holdco/state/HoldCoReducer";
// import dataUploadCenter from "../modules/admin/dataUploadCenters/state/DataUploadCenterReducer";
import dataCenterAutomation from "../modules/dataCenterAutomation/state/DataCenterAutomationReducer";
import common from "../modules/common/state/CommonReducer";
import investor from "../modules/investor-management/state/InvestorReducer";
import dashboard from "../modules/dashboard/state/DashboardReducer";
import documents from "../modules/my-documents/state/DocumentReducer";
import equityType from "../modules/my-documents/state/EquityTypeReducer";
import communication from "../modules/communication/state/CommunicationReducer";
import documentTypeReducer from "../modules/documentMaster/state/documentMasterReducer";
import ContentManagement from "../modules/content-management/state/ContentManagementReducer";

const rootReducer = combineReducers({
    auth,
    user,
    // notification,
    // dataUploadCenter,
    dataCenterAutomation,
    investor,
    common,
    dashboard,
    documents,
    documentTypeReducer,
    equityType,
    communication,
    ContentManagement,
    holdco
});

const sagaMiddleware = createSagaMiddleware();

const store = createStore(rootReducer, initialState, applyMiddleware(sagaMiddleware));

sagaMiddleware.run(rootSaga);

export default store;